import React from "react";
import { Table, DatePicker, Input } from "antd";
import { toast } from "react-toastify";
import Error from "../../Error";
import "./PcrPending.css";
import StatusTag from "../../Common/components/StatusTag";
import { getTestsDataForPcr } from "../../../actions/pcr";

const defaultPageSize = 100;

class PcrPending extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      genistaId: "",
      testsData: [],
      showError: { show: false, message: "" },
      loading: false,
      selectedDate: null,
      paginationConfig: {
        current: 1,
        pageSize: defaultPageSize,
        total: defaultPageSize,
        pageSizeOptions: ["10", "50", "100", "200"],
      },
    };
  }

  handlePageChange = (page, pageSize) => {
    this.setState((prevState) => ({
      paginationConfig: {
        ...prevState.paginationConfig,
        current: page,
        pageSize,
      },
    }));
  }

  loadTestsData = (genistaId) => {
    this.setState({ loading: true }, () => {
      this.apiGetTestsDataForPcr(genistaId).then((res) => {
        if (res) {
          const newData = res || [];
          this.setState({
            testsData: newData,
            loading: false,
          });
          this.setState((prevState) => {
            const newConfig = { ...prevState.paginationConfig };
            newConfig.total = newData.length;
            newConfig.current = 1;
            return { paginationConfig: newConfig };
          });
        } else {
          toast.error("Something went wrong");
          this.setState({
            testsData: [],
            loading: false,
          });
        }
      });
    });
  }

  fetchRetestRecords = () => {
    this.setState({ genistaId: "", selectedDate: null, testsData: [] }, () => this.loadTestsData(""));
  }

  handleDateChange = (e) => {
    this.setState({ selectedDate: e }, () => {
      const { genistaId } = this.state;
      this.loadTestsData(genistaId.trim());
    });
  }

  handleGenistaIdChange = (e) => {
    this.setState({ genistaId: e.target.value });
  }

  handleSearchClick = (value) => {
    const { genistaId } = this.state;
    this.loadTestsData((value ?? genistaId).trim());
  }

  apiGetTestsDataForPcr = async (data) => {
    const { selectedDate } = this.state;
    const options = {
      category: "retest",
      date: selectedDate ? selectedDate.format("MM/DD/YYYY") : "",
    };
    const result = await getTestsDataForPcr(data, options);
    if (result.success) {
      return result.data;
    }
    return null;
  }

  toggleError = (error) => {
    this.setState({ showError: error });
  }

  render() {
    const {
      genistaId,
      testsData,
      showError,
      loading,
      selectedDate,
      paginationConfig,
    } = this.state;
    const tableDataSource = testsData.map((item, index) => ({
      ...item,
      key: `${item.WorkorderId}-${index}`,
    }));

    const tableColumns = [
      {
        title: "Workorder ID",
        dataIndex: "WorkorderId",
        key: "WorkorderId",
        onCell: () => ({ className: "PcrPending__Table__Td" }),
      },
      {
        title: "Genista ID",
        dataIndex: "GenistaId",
        key: "GenistaId",
        onCell: () => ({ className: "PcrPending__Table__Td" }),
      },
      {
        title: "Sample Type",
        dataIndex: "SampleType",
        key: "SampleType",
        onCell: () => ({ className: "PcrPending__Table__Td" }),
      },
      {
        title: "Analysis",
        dataIndex: "Analysis",
        key: "Analysis",
        onCell: () => ({ className: "PcrPending__Table__Td" }),
      },
      {
        title: "Result",
        dataIndex: "Result",
        key: "Result",
        onCell: () => ({ className: "PcrPending__Table__Td" }),
      },
      {
        title: "Status",
        dataIndex: "Status",
        key: "Status",
        render: (status) => <StatusTag type="TEST_STATUS" result={status} />,
        onCell: () => ({ className: "PcrPending__Table__Td" }),
      },
    ];

    return (
      <div className="PcrPending">
        <div className="PcrPending__searchRow">
          <div className="field-container">
            <label>Search</label>
            <Input.Search
              className="PcrGenistaSearch"
              placeholder="Input Genista ID"
              value={genistaId}
              onChange={this.handleGenistaIdChange}
              onSearch={this.handleSearchClick}
              allowClear
            />
          </div>
          <div className="field-container">
            <label>Workorder Date</label>
            <DatePicker
              className="PcrDateFilter"
              format="MM/DD/YYYY"
              placeholder="mm/dd/yyyy"
              value={selectedDate}
              onChange={this.handleDateChange}
              allowClear
              showNow
            />
          </div>
        </div>
        <Table
          sticky
          bordered
          className="PcrPendingTable"
          columns={tableColumns}
          dataSource={tableDataSource}
          scroll={{ y: "60vh" }}
          pagination={{ ...paginationConfig, onChange: this.handlePageChange }}
          loading={loading}
          rowClassName={() => "PcrPending__Table__Tr"}
        />
        <div className="PcrPending__Gap" />
        {showError.show
          && <Error message={showError.message} toggleError={this.toggleError} />}
      </div>
    );
  }
}

export default PcrPending;
